import React from 'react';

import { formatCardNumber } from '@eika-infrastruktur/format';
import { CardImage } from '@eika-kortbetjening/card-list-panel/lib/card-image/CardImage';

import { EligibleCardInfo } from '@generated-types';

import './Click2PayRadioButtonPanel.scss';

interface cardRadioProps {
    card: EligibleCardInfo;
}

const Click2PayRadioOptions = ({ card }: cardRadioProps) => {
    return (
        <div className="card-item">
            <div className="card-item__card-number">{formatCardNumber(card.cardNumber.toString())}</div>
            <div className="card-item__image-container">
                <CardImage imageUrl={card.imagePath} />
            </div>
        </div>
    );
};

export default Click2PayRadioOptions;
